




































































































































































































































































import {Component} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsNavigator from "@/design-system/patterns/Navigator/JdsNavigator.vue"
import JdsNavigatorItem from "@/design-system/patterns/Navigator/JdsNavigatorItem.vue"
import JdsNavigatorBadge from "@/design-system/patterns/Navigator/JdsNavigatorBadge.vue"
import JdsNavigatorItemGroup from "@/design-system/patterns/Navigator/JdsNavigatorItemGroup.vue"
import JdsNavigatorLayout from "@/design-system/patterns/Navigator/JdsNavigatorLayout.vue"
import JdsNavigatorChildItem from "@/design-system/patterns/Navigator/JdsNavigatorChildItem.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdsNavigatorHeading from "@/design-system/patterns/Navigator/JdsNavigatorHeading.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsNavigatorBackLink from "@/design-system/patterns/Navigator/JdsNavigatorBackLink.vue"
import JdsNavigatorFullPageLayout from "@/design-system/patterns/Navigator/JdsNavigatorFullPageLayout.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsLink from "@/design-system/components/Link/JdsLink.vue"

@Component({
    components: {
        JdsLink,
        JdsButton,
        JdsNavigatorFullPageLayout,
        JdsNavigatorBackLink,
        JdiDocs,
        JdsNavigatorHeading,
        JdsGlyph,
        JdsIcon,
        JdsNavigatorChildItem,
        JdsNavigatorLayout,
        JdsNavigatorItemGroup,
        JdsNavigatorBadge, JdsNavigatorItem, JdsNavigator, JdiStatus, JdiContent, JdiPreview
    }
})
export default class Navigator extends Vue {
    nav(path: string) {
        return {
            name: 'docs.patterns.navigator.dummy',
            params: {dummy: path}
        }
    }
}
